import { Component, Element, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { FontType } from '@ugc-utils/utils';
import { Rewarded } from '../../../../icons';
import { rewardedString } from '../../../../icons/rewarded';
@Component({
  tag: 'ugc-review-rewarded',
  shadow: false,
})
export class UgcReviewVerifiedPurchase {
  @Element() el: HTMLElement;
  @Prop() fontType: FontType = FontType.large;
  @Prop() hasRewarded: boolean = false;

  render() {
    const {
      reviewStaticLanguage: { IDS_UGC_REWARDS_REWARDED_REVIEW = '', IDS_UGC_REWARDS_REWARDED_REVIEW_DESC = '' } = {},
      isDesktop,
    } = state;
    const fontType = this.fontType === FontType.large ? 'fs-14' : 'fs-12';

    if (!this.hasRewarded) return null;
    if (isDesktop)
      return (
        <ugc-tooltip
          content={
            IDS_UGC_REWARDS_REWARDED_REVIEW && IDS_UGC_REWARDS_REWARDED_REVIEW_DESC
              ? `<div>
              <div style="display:flex;align-items:center;gap:8px;">
                ${rewardedString}
                <span style="font-size:20px;font-weight:bold;">${IDS_UGC_REWARDS_REWARDED_REVIEW}</span>
              </div>
              <p style="font-size:16px;">${IDS_UGC_REWARDS_REWARDED_REVIEW_DESC}</p>
            </div>`
              : ''
          }
          name="ugc-review-rewarded"
          interactive={false}
        >
          <div class="flex-row-start-center gap-4 pointer">
            <Rewarded width="16" height="16" />
            <span class={`${fontType} c-666`}>{IDS_UGC_REWARDS_REWARDED_REVIEW}</span>
          </div>
        </ugc-tooltip>
      );
    return (
      <div class="flex-row-start-center gap-4 pointer" onClick={() => (state.isShowRewardedReview = true)}>
        <Rewarded width="16" height="16" />
        <span class={`${fontType} c-666`}>{IDS_UGC_REWARDS_REWARDED_REVIEW}</span>
      </div>
    );
  }
}
